const axios = require('axios')
// import { request, HttpError } from '@helpers/general'

// eslint-disable-next-line import/prefer-default-export
export const fetchEncryptedSDP = (promocode = 'UOM') =>
  axios
    .get(`${process.env.GATSBY_SYNCHRONY_SERVICE_URL}/storecart/edp?promocode=${promocode}`)
    .then(response => response.data)
